import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { AuthApiService } from '../../../core/modules/auth/auth-api.service';

@Component({
  selector: 'tax-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['../forms.sass', './restore-password.component.sass'],
})
export class RestorePasswordComponent implements OnDestroy {
  private subscription: Subscription[] = [];
  login: string = '';
  hasError = false;

  constructor(
    private authApiService: AuthApiService,
    private location: Location,
  ) {}

  ngOnDestroy(): void {
    this.subscription.map((item: Subscription) => item.unsubscribe());
  }

  back(): void {
    this.location.back();
  }

  submit(): void {
    this.hasError = false;
    this.subscription.push(this.authApiService.sendLogin(this.login).subscribe(
      () => {
      },
      () => {
        this.hasError = true;
      },
    ));
  }
}
